<ng-container *ngIf="form" [formGroup]="form">
  <div class="_2up-dropdown-wrapper">
    <div class="left-column-wrapper">
      <div class="title">Check in after</div>
      <ng-select
      id="checkIn"
        class="dropdown w-dropdown dropdown-toggle"
        [formControl]="checkIn"
        [clearable]="false"
        placeholder="Select"
      >
        <ng-container *ngFor="let time of times">
          <ng-option [value]="time.value" *ngIf="!checkOut?.value || time.value >= checkOut?.value">
            {{ time.name }}
          </ng-option>
        </ng-container>
      </ng-select>
      <p *ngIf="!checkOut.valid && (checkOut.touched || checkOut.dirty)" class="alert-danger">
        <i class="icon-cnt-times-circle"></i>
        Select check in time.
      </p>
    </div>
    <div class="right-column-wrapper">
      <div class="title">Check out before</div>
      <ng-select
      id="checkOut"
        class="dropdown w-dropdown dropdown-toggle"
        [formControl]="checkOut"
        [clearable]="false"
        placeholder="Select"
      >
        <ng-container *ngFor="let time of times">
          <ng-option [value]="time.value" *ngIf="!checkIn?.value || time.value <= checkIn?.value">
            {{ time.name }}
          </ng-option>
        </ng-container>
      </ng-select>
      <p *ngIf="!checkIn.valid && (checkOut.touched || checkOut.dirty)" class="alert-danger">
        <i class="icon-cnt-times-circle"></i>
        Select check out time.
      </p>
    </div>
  </div>

  <div class="_2up-dropdown-wrapper">
    <div class="left-column-wrapper">
      <div class="title">Minimum night stay</div>
      <ng-select
        [formControl]="minLengthOfStayInDays"
        [clearable]="false"
        placeholder="Select"
        id="minLengthOfStayInDays"
        class="dropdown w-dropdown dropdown-toggle"
      >
        <ng-option [value]="1" *ngIf="!maxLengthOfStayInDays?.value || 1 <= maxLengthOfStayInDays?.value">
          1 night
        </ng-option>
        <ng-option [value]="2" *ngIf="!maxLengthOfStayInDays?.value || 2 <= maxLengthOfStayInDays?.value">
          2 nights
        </ng-option>
        <ng-option [value]="3" *ngIf="!maxLengthOfStayInDays?.value || 3 <= maxLengthOfStayInDays?.value">
          3 nights
        </ng-option>
        <ng-option [value]="5" *ngIf="!maxLengthOfStayInDays?.value || 5 <= maxLengthOfStayInDays?.value">
          5 nights
        </ng-option>
        <ng-option [value]="6" *ngIf="!maxLengthOfStayInDays?.value || 6 <= maxLengthOfStayInDays?.value">
          6 nights
        </ng-option>
        <ng-option [value]="7" *ngIf="!maxLengthOfStayInDays?.value || 7 <= maxLengthOfStayInDays?.value">
          1 week
        </ng-option>
        <ng-option [value]="14" *ngIf="!maxLengthOfStayInDays?.value || 14 <= maxLengthOfStayInDays?.value">
          2 weeks
        </ng-option>
        <ng-option [value]="30" *ngIf="!maxLengthOfStayInDays?.value || 30 <= maxLengthOfStayInDays?.value">
          1 month
        </ng-option>
      </ng-select>
      <p
        *ngIf="!minLengthOfStayInDays.valid && (minLengthOfStayInDays.touched || minLengthOfStayInDays.dirty)"
        class="alert-danger"
      >
        <i class="icon-cnt-times-circle"></i>
        Select minimum length of stay.
      </p>
    </div>
    <div class="right-column-wrapper">
      <div class="title">Maximum night stay</div>
      <ng-select
        [formControl]="maxLengthOfStayInDays"
        [clearable]="false"
        placeholder="Select"
        id="maxLengthOfStayInDays"
        class="dropdown w-dropdown dropdown-toggle"
      >
        <ng-option [value]="1" *ngIf="!minLengthOfStayInDays?.value || 1 >= minLengthOfStayInDays?.value">
          1 night
        </ng-option>
        <ng-option [value]="2" *ngIf="!minLengthOfStayInDays?.value || 2 >= minLengthOfStayInDays?.value">
          2 nights
        </ng-option>
        <ng-option [value]="3" *ngIf="!minLengthOfStayInDays?.value || 3 >= minLengthOfStayInDays?.value">
          3 nights
        </ng-option>
        <ng-option [value]="5" *ngIf="!minLengthOfStayInDays?.value || 5 >= minLengthOfStayInDays?.value">
          5 nights
        </ng-option>
        <ng-option [value]="6" *ngIf="!minLengthOfStayInDays?.value || 6 >= minLengthOfStayInDays?.value">
          6 nights
        </ng-option>
        <ng-option [value]="7" *ngIf="!minLengthOfStayInDays?.value || 7 >= minLengthOfStayInDays?.value">
          1 week
        </ng-option>
        <ng-option [value]="14" *ngIf="!minLengthOfStayInDays?.value || 14 >= minLengthOfStayInDays?.value">
          2 weeks
        </ng-option>
        <ng-option [value]="30" *ngIf="!minLengthOfStayInDays?.value || 30 >= minLengthOfStayInDays?.value">
          1 month
        </ng-option>
      </ng-select>
      <p
        *ngIf="!maxLengthOfStayInDays.valid && (maxLengthOfStayInDays.touched || maxLengthOfStayInDays.dirty)"
        class="alert-danger"
      >
        <i class="icon-cnt-times-circle"></i>
        Select maximum length of stay.
      </p>
    </div>
  </div>

  <div class="_1up-outer-wrapper">
    <div>
      <div class="title">Minimum request notice</div>
      <ng-select
        [formControl]="reserveDaysInAdvance"
        [clearable]="false"
        placeholder="Select"
        id="reserveDaysInAdvance"
        class="dropdown w-dropdown dropdown-toggle"
      >
        <ng-option [value]="0" [disabled]="disallowShortRequestNotice">
          No notice <span *ngIf="disallowShortRequestNotice">(Requires Instant Bookings)</span>
        </ng-option>
        <ng-option [value]="0.5" [disabled]="disallowShortRequestNotice">
          12 hours <span *ngIf="disallowShortRequestNotice">(Requires Instant Bookings)</span>
        </ng-option>
        <ng-option [value]="1">24 hours</ng-option>
        <ng-option [value]="2">48 hours</ng-option>
      </ng-select>
    </div>
    <p
      *ngIf="!reserveDaysInAdvance.valid && (reserveDaysInAdvance.touched || reserveDaysInAdvance.dirty)"
      class="alert-danger"
    >
      <i class="icon-cnt-times-circle"></i>
      Let us know how much advance notice you would like to have for bookings.
    </p>
  </div>
  <div class="_1up-outer-wrapper">
    <div class="_1up-wrapper">
      <div class="title">Maximum request notice</div>
      <ng-select
        [formControl]="bookingWindow"
        [clearable]="false"
        placeholder="Select"
        id="bookingWindow"
        class="dropdown w-dropdown dropdown-toggle"
      >
        <ng-option [value]="7">1 week in advance</ng-option>
        <ng-option [value]="30">1 month in advance</ng-option>
        <ng-option [value]="91">3 months in advance</ng-option>
        <ng-option [value]="182">6 months in advance</ng-option>
        <ng-option [value]="273">9 months in advance</ng-option>
        <ng-option [value]="365">12 months in advance</ng-option>
        <ng-option [value]="547">18 months in advance</ng-option>
      </ng-select>
    </div>
    <p *ngIf="!bookingWindow.valid && (bookingWindow.touched || bookingWindow.dirty)" class="alert-danger">
      <i class="icon-cnt-times-circle"></i>
      Select the maximum time in advance that a booking can be requested.
    </p>
  </div>
  <div class="_1up-outer-wrapper">
    <div class="_1up-wrapper">
      <div class="title">Check-in process</div>
      <ng-select
        [formControl]="checkInProcess"
        [clearable]="false"
        id="checkInProcess"
        class="dropdown w-dropdown dropdown-toggle"
        placeholder="Select"
      >
        <ng-option
          *ngFor="let checkInProcessType of checkInProcessTypes | enumSelector"
          [value]="checkInProcessType.key"
        >
          {{ checkInProcessType.value }}
        </ng-option>
      </ng-select>
    </div>
    <p *ngIf="!checkInProcess.valid && (checkInProcess.touched || checkInProcess.dirty)" class="alert-danger">
      <i class="icon-cnt-times-circle"></i>
      Please make a selection for your site's check in process.
    </p>
  </div>
  <div class="_1up-outer-wrapper">
    <div class="_1up-wrapper">
      <div class="title">Bookability</div>
      <ng-select
        [formControl]="reservationProcess"
        [clearable]="false"
        id="reservationProcess"
        class="dropdown w-dropdown dropdown-toggle"
        placeholder="Select"
      >
        <ng-option value="standard" [disabled]="disallowBookingRequestOption">
          Only allow booking requests
          <span *ngIf="disallowBookingRequestOption">(Requires 24 hours or more notice)</span>
        </ng-option>
        <ng-option value="instant"> Allow instant bookings </ng-option>
      </ng-select>
    </div>
    <p
      *ngIf="!reservationProcess.valid && (reservationProcess.touched || reservationProcess.dirty)"
      class="alert-danger"
    >
      <i class="icon-cnt-times-circle"></i>
      Please select a method for guests to book your site.
    </p>
  </div>
</ng-container>
